import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/vhosts/icarmenia.am/httpdocs/frontend/src/modules/CouncilMeetings/individual/template.js");
